import {FC} from 'react'
import {Container, Navbar} from 'react-bootstrap'
import {useUser} from '../../contexts/UserContext'
import MobileNavigation from './MobileNavigation'
import DesktopNavigation from './DesktopNavigation'
import {useResponsiveNavigation} from './utils/navigationHelpers'

const NavigationHeader: FC = () => {
    const {user} = useUser()
    const {isMobile, isTabletPortrait, isTabletLandscape, isDesktop} = useResponsiveNavigation()

    // Show mobile navigation for: mobile screens OR tablet in portrait
    const showMobileNav = isMobile || isTabletPortrait

    // Show desktop navigation with megamenu for: desktop OR tablet in landscape
    const showDesktopNav = isDesktop || isTabletLandscape

    // Use tap trigger for tablet landscape (instead of hover)
    const useTapTrigger = isTabletLandscape

    if (!user) {
        return null
    }

    return (
        <Navbar
            expand="lg"
            sticky={showMobileNav ? undefined : "top"}
            style={{
                minHeight: showMobileNav ? '60px' : '72px',
                backgroundColor: '#1C1C1C',
                paddingBottom: showMobileNav ? '0.5rem' : undefined
            }}
        >
            <Container fluid="xl" className={showMobileNav ? 'p-0' : ''}>
                {showMobileNav ? (
                    <MobileNavigation user={user}/>
                ) : showDesktopNav ? (
                    <DesktopNavigation user={user} useTapTrigger={useTapTrigger}/>
                ) : null}
            </Container>
        </Navbar>
    )
}

export default NavigationHeader
